import type { Permission } from '@/data'
import { buildQuery, type ListParams } from '@/api/client'
import api from '.'

export interface PaginatedPermissions {
  data: Permission[]
  meta: {
    current_page: number
    last_page: number
    per_page: number
    total: number
  }
}

export async function getPermissions(
  params?: ListParams,
): Promise<PaginatedPermissions> {
  const res = await api.get('/', {
    params: buildQuery(params),
  })

  return {
    data: res.data.data,
    meta: res.data.meta,
  }
}

export async function getAllPermissions() {
  let page = 1
  let lastPage = 1
  const permissions: Permission[] = []

  do {
    const response = await getPermissions({ page })
    permissions.push(...response.data)
    lastPage = response.meta.last_page
    page += 1
  } while (page <= lastPage)

  return permissions
}
